/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Wallet identifier
 */

export type WalletId = t.TypeOf<typeof WalletId>;
export const WalletId = t.string;
